import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/index.js'
Vue.use(VueRouter)

// 解决重复点击路由报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export const constRoutes = [
  {
    path: '/',
    // redirect: '/index',
    component: () => import('@/views/home/index.vue'),
    meta: {}
  },
  // {
  //   path: '/index',
  //   name: 'Home',
  //   component: () => import('@/views/home/index.vue')
  // },

]
export const asyncRoutes = () => []

const router = new VueRouter({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: constRoutes
})
export default router
